import React, { useEffect, useState, useRef } from 'react';
import API from '../api';
import { compressImage } from '../utils';
import { IcPlus, IcTrash, IcUser, IcX } from './Icons';

const emptyForm = { first_name: '', last_name: '', subject: '', email: '', phone: '' };

export default function Teachers() {
  const [teachers, setTeachers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [form, setForm] = useState(emptyForm);
  const fileRef = useRef();

  const load = () => API.get('/teachers/school/1').then(r => setTeachers(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const submit = async () => {
    if (!fileRef.current?.files[0]) return setMsg('Photo requise');
    setLoading(true); setMsg('');
    const compressed = await compressImage(fileRef.current.files[0]);
    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => fd.append(k, v));
    fd.append('school_id', 1);
    fd.append('photo', compressed, 'photo.jpg');
    try {
      await API.post('/teachers/register', fd);
      setForm(emptyForm);
      fileRef.current.value = '';
      setShowForm(false);
      load();
    } catch (e) { setMsg(e.response?.data?.detail || 'Erreur'); }
    setLoading(false);
  };

  const del = async (id) => {
    if (!window.confirm('Supprimer cet enseignant ?')) return;
    await API.delete(`/teachers/${id}`);
    load();
  };

  const F = ({ label, k, type = 'text' }) => (
    <div>
      <label className="label">{label}</label>
      <input className="input" type={type} value={form[k]} onChange={e => setForm(f => ({ ...f, [k]: e.target.value }))} />
    </div>
  );

  return (
    <div style={{ padding: 28 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
        <div>
          <h1 className="page-title">Enseignants</h1>
          <p className="page-subtitle">{teachers.length} enseignant{teachers.length > 1 ? 's' : ''} enregistré{teachers.length > 1 ? 's' : ''}</p>
        </div>
        <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>
          <IcPlus size={15} strokeWidth={2.5} /> Ajouter
        </button>
      </div>

      {showForm && (
        <div className="card" style={{ padding: 24, marginBottom: 20 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
            <div style={{ fontWeight: 600, fontSize: 14 }}>Nouvel enseignant</div>
            <button className="btn btn-ghost btn-icon" onClick={() => setShowForm(false)}><IcX size={15} /></button>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 14, marginBottom: 14 }}>
            <F label="Prénom" k="first_name" />
            <F label="Nom de famille" k="last_name" />
            <F label="Matière enseignée" k="subject" />
            <F label="Email" k="email" type="email" />
            <F label="Téléphone" k="phone" type="tel" />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label className="label">Photo</label>
            <input ref={fileRef} type="file" accept="image/*" className="input" style={{ paddingTop: 6 }} />
          </div>
          {msg && <div style={{ padding: '8px 12px', background: 'var(--red-l)', color: 'var(--red)', borderRadius: 7, fontSize: 12, marginBottom: 12 }}>{msg}</div>}
          <div style={{ display: 'flex', gap: 10 }}>
            <button className="btn btn-primary" onClick={submit} disabled={loading}>{loading ? 'Enregistrement...' : 'Enregistrer'}</button>
            <button className="btn btn-ghost" onClick={() => setShowForm(false)}>Annuler</button>
          </div>
        </div>
      )}

      <div className="card" style={{ overflow: 'hidden' }}>
        {teachers.length === 0 ? (
          <div className="empty">
            <IcUser size={40} stroke="var(--slate-300)" />
            <p style={{ marginTop: 12 }}>Aucun enseignant enregistré</p>
          </div>
        ) : (
          <table>
            <thead>
              <tr><th>Enseignant</th><th>Matière</th><th>Email</th><th>Téléphone</th><th></th></tr>
            </thead>
            <tbody>
              {teachers.map(t => (
                <tr key={t.id}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      {t.photo_url
                        ? <img src={t.photo_url} alt="" style={{ width: 36, height: 36, borderRadius: '50%', objectFit: 'cover', flexShrink: 0, border: '2px solid var(--slate-200)' }} />
                        : <div className="avatar av-md av-amber">{t.first_name[0]}{t.last_name[0]}</div>
                      }
                      <div style={{ fontWeight: 600, color: 'var(--slate-800)', fontSize: 13 }}>{t.first_name} {t.last_name}</div>
                    </div>
                  </td>
                  <td><span className="badge badge-amber">{t.subject}</span></td>
                  <td style={{ color: 'var(--slate-400)', fontSize: 12 }}>{t.email}</td>
                  <td style={{ color: 'var(--slate-400)', fontSize: 12 }}>{t.phone || '—'}</td>
                  <td>
                    <button className="btn btn-danger btn-sm btn-icon" onClick={() => del(t.id)}>
                      <IcTrash size={13} strokeWidth={2} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
